import React, { useCallback, useEffect, useState } from 'react';
import { PageWrap } from '../components/Main';
import { Box, Button, FormField, Input, Text } from '../components/ui';
import { useRequestResetPasswordMutation } from '../graphql';
import Register from '../components/layouts/Register';
import { clearToken } from '../components/hooks/useLogout';

const ForgotPassword = (): JSX.Element => {
  const [status, setStatus] = useState<JSX.Element | string | null>(null);
  const [email, setEmail] = useState<string>('');

  const [
    requestResetPassword,
    { error: requestResetPasswordError, data: requestResetPasswordResult },
  ] = useRequestResetPasswordMutation();

  const onSubmit = useCallback(async () => {
    if (typeof email !== 'string' || email.trim().length === 0) {
      setStatus('Invalid email address');
      return;
    }

    setStatus('Requesting...');

    requestResetPassword({
      variables: {
        input: {
          email: email.toLowerCase(),
        },
      },
    });
  }, [email, requestResetPassword]);

  useEffect(() => {
    if (requestResetPasswordError) {
      setStatus(
        <div style={{ marginTop: '0.5em' }}>
          {requestResetPasswordError.message ===
          'You cannot reset the password of a deactivated account!' // Only expose this error message to user, otherwise keep them hidden as previous
            ? 'You cannot reset the password of a deactivated account!'
            : 'Password reset request failed for an unknown reason.'}
        </div>,
      );
    }
  }, [requestResetPasswordError]);

  useEffect(() => {
    if (requestResetPasswordResult) {
      setStatus(
        <>
          Request succeeded. If an account matching the email address you
          specified exists you should receive an email with instructions
          briefly. Go back to <a href="/login">login</a>
        </>,
      );
    }
  }, [requestResetPasswordResult]);

  useEffect(() => {
    clearToken();
  }, []);

  return (
    <PageWrap>
      <Register>
        <Box width="100%">
          <form action="javascript:void(0);">
            <FormField label="Login email address">
              <Input
                type="email"
                name="email"
                autoComplete="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
                height="3rem"
                border="1px solid #ccc"
              />
            </FormField>
            <Button variant="primary" onPress={onSubmit} width="100%">
              Request password reset
            </Button>
            {status && (
              <Box
                bg="neutral.white_100"
                borderWidth="1px"
                borderStyle="solid"
                borderColor="neutral.gray_225"
                p={3}
                mt={4}
              >
                <Text>{status}</Text>
              </Box>
            )}
          </form>
        </Box>
      </Register>
    </PageWrap>
  );
};

ForgotPassword.publicPage = true;
export default ForgotPassword;
